// Single source of truth lives in `@cede/types`, beside the zod schema that
// validates it at the API boundary — re-exported here so the many existing
// `@cede/utils` importers are unaffected.
export { APP_SOURCE, type AppSource } from "@cede/types";
